module.exports = __webpack_public_path__ + "img/1J7.9e955198.png";